import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import routeMeta from './routeMeta.json';

/**
 * Keeps <title>, the meta description and the canonical link in step with
 * the current route.
 *
 * This exists because react-helmet-async 2.0.5 injects nothing in this app -
 * document.head only ever held the static tags from public/index.html, so
 * every page shared one title. Rather than debug the library, metadata for
 * every route lives in routeMeta.json, which scripts/prerender.js also reads
 * to write the static HTML that crawlers see. One source, two consumers.
 *
 * Call once, high in the tree, inside the Router.
 */
export default function useRouteMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    const normalized =
      pathname.length > 1 && pathname.endsWith('/')
        ? pathname.slice(0, -1)
        : pathname;

    const match = routeMeta.routes.find((r) => r.path === normalized);
    if (!match) return; // unknown route: leave index.html's defaults alone

    document.title = match.title;

    let description = document.querySelector('meta[name="description"]');
    if (!description) {
      description = document.createElement('meta');
      description.setAttribute('name', 'description');
      document.head.appendChild(description);
    }
    description.setAttribute('content', match.description);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute(
      'href',
      routeMeta.siteUrl + (normalized === '/' ? '/' : normalized)
    );
  }, [pathname]);
}
